module.exports = __webpack_public_path__ + "img/regular_lease_overview_icon02.96a15ed5.svg";